import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { registerMap, EChartsOption  } from 'echarts';
import { ActivatedRoute, Router } from '@angular/router';
import { ZWebSocket } from '../ZWebSocket';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss']
})
export class GraphComponent implements OnInit 
{

    // Conexão com o servidor
    private websocket: ZWebSocket = null;    

    public tracks = [];
    public trackNames = [];
    public loaded = false;
    public option = {

    }

    public mapPointer = [100,100,100];
    public deltaDataset = [];
    public realtimeDeltaDataset = [];
    public referenceTime = {};

    public update: EChartsOption = {
        /*grid3D: {
            viewControl: {

            }
        },*/
       series: []
    }

    public trackName = null;
    public error = null;
    public realtime = [];
    public currentLapSource = [];

    public lineStyles = {
        reference: {
            width: 1.5,
            color: 'purple'
        },
        furiacs: {
            width: 1.5,
            color: 'green'
        },
        realtime: {
            width: 1.5,
            color: 'white',
            opacity: 0.7
        },
        delta: {
            width: 1.5,
            color: 'red',
            opacity: 0.7
        }
    };
    public pointerCoords = [[0,0,0]];


    public yAxisSplitLine = {
        lineStyle: {
            color: '#111'
        }
    };

    public calcularDeltaAcumulado = function(fonte1, fonte2, passo = 0.5) {
        // 1. Determina o range de distância comum
        const maxDist = Math.max(fonte1.at(-1)[0], fonte2.at(-1)[0]);
        const distGrid = [];
        for (let d = 0; d <= maxDist; d += passo) distGrid.push(d);
      
        // 2. Função auxiliar de interpolação linear
        function interp(x, data) {
          for (let i = 0; i < data.length - 1; i++) {
            const [x1, y1] = data[i];
            const [x2, y2] = data[i + 1];
            if (x >= x1 && x <= x2) {
              const t = (x - x1) / (x2 - x1);
              return y1 + t * (y2 - y1);
            }
          }
          // extrapola leve nos extremos
          if (x < data[0][0]) return data[0][1];
          if (x > data.at(-1)[0]) return data.at(-1)[1];
        }
      
        // 3. Calcula o delta ponto a ponto
        const deltas = distGrid.map(d => {
          const t1 = interp(d, fonte1);
          const t2 = interp(d, fonte2);
          return { dist: d, delta: t2 - t1 };
        });
      
        // 4. Calcula o delta acumulado
        let acumulado = 0;
        const resultado = deltas.map((p, i) => {
          if (i > 0) {
            const diff = (p.delta - deltas[i - 1].delta);
            acumulado += diff;
          }
          return [p.dist, acumulado];
        });
      
        return resultado;
      }
      
      public calcularDeltaAbsoluto = function(fonte1, fonte2, passo = 0.5) {
  // Limita ao trecho comum
  const maxDist = Math.min(fonte1.at(-1)[0], fonte2.at(-1)[0]);
  const distGrid = [];
  for (let d = 0; d <= maxDist; d += passo) distGrid.push(d);

  // Função auxiliar: integra distância e velocidade em tempo
  function integrarTempo(fonte) {
    const tempos = [[fonte[0][0], 0]]; // começa no tempo zero
    for (let i = 1; i < fonte.length; i++) {
      const [d1, v1_kmh] = fonte[i - 1];
      const [d2, v2_kmh] = fonte[i];
      const v1 = v1_kmh / 3.6;
      const v2 = v2_kmh / 3.6;
      const ds = d2 - d1;
      const vMed = (v1 + v2) / 2;
      const dt = ds / vMed; // tempo incremental em segundos
      tempos.push([d2, tempos[i - 1][1] + dt]);
    }
    return tempos;
  }

  // Interpolação linear
  function interp(x, data) {
    for (let i = 0; i < data.length - 1; i++) {
      const [x1, y1] = data[i];
      const [x2, y2] = data[i + 1];
      if (x >= x1 && x <= x2) {
        const t = (x - x1) / (x2 - x1);
        return y1 + t * (y2 - y1);
      }
    }
    if (x < data[0][0]) return data[0][1];
    if (x > data.at(-1)[0]) return data.at(-1)[1];
  }

  // 1️⃣ Calcula tempos acumulados das duas fontes
  const tempo1 = integrarTempo(fonte1);
  const tempo2 = integrarTempo(fonte2);

  // 2️⃣ Interpola para grid comum e calcula delta
  const resultado = distGrid.map(d => {
    const t1 = interp(d, tempo1);
    const t2 = interp(d, tempo2);
    return [d, t2 - t1];
  });

  return resultado;
      }
      
public criarCalculadoraDelta = function(fonte1) {
    // 🔧 Função de interpolação linear
    function interp(x, data) {
      for (let i = 0; i < data.length - 1; i++) {
        const [x1, y1] = data[i];
        const [x2, y2] = data[i + 1];
        if (x >= x1 && x <= x2) {
          const t = (x - x1) / (x2 - x1);
          return y1 + t * (y2 - y1);
        }
      }
      if (x < data[0][0]) return data[0][1];
      if (x > data.at(-1)[0]) return data.at(-1)[1];
    }
  
    // 🔹 Pré-calcula tempo acumulado da volta de referência (fonte 1)
    const tempo1 = [[fonte1[0][0], 0]];
    for (let i = 1; i < fonte1.length; i++) {
      const [d1, v1] = fonte1[i - 1];
      const [d2, v2] = fonte1[i];
      const vMed = ((v1 + v2) / 2) / 3.6;
      const ds = d2 - d1;
      const dt = ds / vMed;
      tempo1.push([d2, tempo1[i - 1][1] + dt]);
    }
  
    // 🔹 Estado interno (para acumular tempo da volta 2)
    let distanciaAnterior = null;
    let tempoAcumuladoFonte2 = 0;
  
    // 🔹 Função que recebe nova leitura e devolve delta atual
    return function atualizarDelta(distanciaAtual, velocidadeAtual) {
      if (distanciaAnterior !== null) {
        const ds = distanciaAtual - distanciaAnterior;
        if (ds > 0) {
          const vMed = velocidadeAtual / 3.6; // m/s
          const dt = ds / vMed;
          tempoAcumuladoFonte2 += dt;
        }
      }
  
      const tempoReferencia = interp(distanciaAtual, tempo1);
      const delta = tempoAcumuladoFonte2 - tempoReferencia;
  
      distanciaAnterior = distanciaAtual;
  
      return delta; // positivo = mais lento, negativo = mais rápido
    };
  }

    constructor(public httpClient: HttpClient, public activatedRoute: ActivatedRoute, public router: Router)
    {
//         // Instância para conexão com o servidor
//         this.websocket = new ZWebSocket('ws://localhost:8080', { interval: 5000, enabled: true });

//         this.websocket.on('connected', () => {
//             this.currentLapSource = [];
//         })

//         // Evento de recebimento de mensagem
//         this.websocket.on('message', (message) =>
//         {
//           //  console.log(message)
//             // Limpeza de dados?
//             if (message.command === 'clear')
//             {
//                 console.log('clear')
//                 this.currentLapSource = [];
//                 this.realtimeDeltaDataset = [];
                
//             }
//             else if (message.command === 'frames')
//             {
//                 for (const m of message.data)
//                 {
//                     m[0] = `${m[0]}m`
//                     this.currentLapSource.push(m);

//                     if (m[11]>0)
//                     this.realtimeDeltaDataset.push([m[0], m[11]-this.referenceTime[m[0]]])
//                 }

                



//                 /*console.log(message)
//                 message[0] = `${message[0]}m`;
//                 this.realtime.push(message);
    
//                 this.update = {
//                     dataset: [
//                         {},
//                         {},
//                         {},
//                         { source: this.realtime }
//                     ]
//                 }*/
//             }

//             this.update = {
//                 dataset: [
//                     {},
//                     {},
//                     {},
//                     { 
//                         source:  this.currentLapSource 
//                     },
//                     {
//                         source: this.realtimeDeltaDataset
//                     }
//                 ]
//             }            

//  console.log(this.update)
//         });

//         //this.trackName = activatedRoute.snapshot.paramMap.get("trackName");

//         // this.activatedRoute.queryParams
//         // .subscribe(params => {
//         //   console.log(params); // { orderby: "price" }

//         //     if (params === null || !params.track)
//         //     {
//         //         console.log('nave')
//         //         location.href = 'tracks?track=barein'
//         //         //router.navigate(['/tracks', {queryParams: {track: 'barein'}}]);
//         //     }
//         //     else
//         //         this.trackName = params.track;

//        // }
//      // );
    }

    public instance = null;

    public x = 0;
    public y = 0;
    public z = 0;

    onChartInit(ec) 
    {
        this.instance = ec;
    }

    zoomToPoint(data) {
        //console.log(data[8],data[9],data[10])

        // this.x = data[8]/50;
        // this.y = data[9]/50;
        // //this.z = data[10]/50;

        this.update = 
        {
            series: [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                { data: [[data[10],data[8],0]]},
            ]
        }
        //     grid3D: {
        //       viewControl: {
        //         center: [this.x, this.y, this.z],
        //         distance: 50
        //       },
        //     },
        //   }


        // const [x, y, z] = point;
        // console.log(point)
    
        // // Ajuste de câmera baseado na posição
        // const beta = 0;//(x / 60) * 90 + 30;
        // const alpha = 25;// + (z / 20) * 10;
        // const distance = 300;

        // this.update = 
        // {
        //     grid3D: {
        //       viewControl: {
        //         alpha,
        //         beta,
        //         distance,
        //         center: [0, 0, 0],
        //         animation: true,
        //       },
        //     },
        //   }
    
        // this.instance.setOption({
        //   grid3D: {
        //     viewControl: {
        //       alpha,
        //       beta,
        //       distance,
        //       center: [x, y, z],
        //       animation: true,
        //     },
        //   },
        // }, false);
    }

    resizeChart() 
    {
        if (this.instance)
        {
            this.instance.resize();
        }
    }

    public changes = [];

    public roundDistance(distance)
    {
        return Math.round(distance*10);
    }

    async ngOnInit() 
    {
        setInterval(() =>
        {
            if (this.changes.length > 0)
            {
                for (const change of this.changes)
                    this.update = change;

                this.changes = []
            }
        }, 200);

        const tracks = await new Promise<any>((resolve) => {

            this.httpClient.get(`assets/tracks.json`, {responseType: 'text'}).subscribe(
            response => 
            {
                resolve(JSON.parse(response));  
            }, 
            (error) => 
            {
                console.log(error);
                resolve(null);
            });
        });        

        if (tracks)
            this.tracks = tracks.tracks;
            this.trackNames = tracks.trackNames;

        // registerMap('Map', 
        //     {
        //         "type":"FeatureCollection","features": 
        //         [
        //             {
        //                 "type":"Feature",
        //                 "id":"1",
        //                 "properties":{
        //                     "name":"Stub"
        //                 },
        //                 "geometry": {
        //                     "type": "LineString",
        //                 "coordinates": [[-1000,-1000],[-1000,1000],[1000,1000],[1000,-1000],[-1000,-1000]]
        //                 }
        //             }
        //         ]
        //     }, 
        //     /*{
        //         Stub: {
        //           left: -200,
        //           top: -1000,

        //           //width: 4000,
        //           //height: 4000
        //         }
        //     }*/
        // );



    }

    public async Load(track)
    {
        this.trackName = track;

        const furiacs = await new Promise<any>((resolve) => {

            this.httpClient.get(`assets/${this.trackName}-furiacs.txt`, {responseType: 'text'}).subscribe(
            response => 
            {
                resolve(JSON.parse(response));  
            }, 
            (error) => 
            {
                console.log(error);
                resolve(null);
            });
        });


        if (furiacs === null)
        {
            this.error = `Arquivo assets/${this.trackName}-furiacs não encontrado`;
            return;
        }

        const reference = await new Promise<any>((resolve) => {

            this.httpClient.get(`assets/${this.trackName}-reference.txt`, {responseType: 'text'}).subscribe(
            response => 
            {
                resolve(JSON.parse(response));  
            },
            (error) =>
            {
                console.log(error);
                resolve(null);
            });

        });

        if (reference === null)
        {
            this.error = `Arquivo assets/${this.trackName}-reference não encontrado`;
            return;
        }
        


        // Quantidade de informações
        let furiacsLength = furiacs.data.brake.length;
        let referenceLength = reference.data.brake.length;

        // let furiacsMaxDistance = this.roundDistance(furiacs.data.maxDistance);
        // let referenceMaxDistance = this.roundDistance(reference.data.maxDistance);

        // const maxDistance = (furiacsMaxDistance > referenceMaxDistance) ? furiacsMaxDistance : referenceMaxDistance;
        // console.log(`MaxDistantance (array length): ${maxDistance}`)

        // // Vamos indexar as distâncias.
        // // Distancia absoluta vai equivaler à uma posição no array de dados
        // const absDistance = {};
        // let currentIndex = 0;

        // for (let i = 0; i < maxDistance; i++)
        // {
        //     const currentDistance = this.roundDistance(furiacs.data.distance[currentIndex]);

        //     if (i < currentDistance)
        //     {
        //         currentIndex++;
        //     }

        //     //absDistance[i] = currentIndex;
        //     console.log(i, currentIndex)
        // }

        // console.log(absDistance)
        // return;

        // for (let i = 0; i < furiacsLength; i++)
        // {
        //     console.log(this.roundDistance(furiacs.data.distance[i]))
        // }


        // Coordenadas geográficas
        const referenceData = [];
        const furiacsData = [];

        const referenceCoords = [];
        const furiacsCoords = [/*[0,0,0,0],
                               [1,1,0,1],
                               [2,2,0,2],
                               [2,1,0,3],*/
                            ];



        //console.log(furiacsLength,referenceLength)
        let de = '';
        const fonte1 = [];
        const fonte2 = [];

        for (let i = 0; i < referenceLength; i++)
        {
            referenceData.push([
                reference.data.distance[i],
                reference.data.speed[i],
                reference.data.throttle[i],
                reference.data.brake[i],
                reference.data.gear[i],
                reference.data.rpm[i],
                0,
                reference.data.steering[i],
                reference.data.position[i].x,
                reference.data.position[i].y,
                reference.data.position[i].z,
                // delta
                0
            ])

           referenceCoords.push([
                reference.data.position[i].z,
                reference.data.position[i].x,
                0
            ])  
            
            //if (i < 50)
            //    de += `[${reference.data.position[i].z},${reference.data.position[i].x},0],`            


                fonte2.push([reference.data.distance[i], reference.data.speed[i]])
           // if (i < 5)
            //    console.log(Math.round(reference.data.distance[i]*10))
        }   
        


        const calcDelta = this.criarCalculadoraDelta(fonte2);

        for (let i = 0; i < furiacsLength; i++)
        {
            furiacsData.push([
                furiacs.data.distance[i],
                furiacs.data.speed[i],
                furiacs.data.throttle[i],
                furiacs.data.brake[i],
                furiacs.data.gear[i],
                furiacs.data.rpm[i],
                0,
                furiacs.data.steering[i],
                furiacs.data.position[i].x,
                furiacs.data.position[i].y,
                furiacs.data.position[i].z,
                calcDelta(furiacs.data.distance[i], furiacs.data.speed[i])
            ]);

//'distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'time'

            furiacsCoords.push([
                furiacs.data.position[i].z,
                furiacs.data.position[i].x,
                0
            ])
           // fonte1.push([furiacs.data.distance[i], furiacs.data.speed[i]])

           // if (i < 20)
           //     de += `${furiacs.data.distance[i]}\t${furiacs.data.speed[i]}\n`
                //console.log(furiacs.data.distance[i]\t))
        }


     

//  console.log(furiacsData)
//  console.log(referenceData)
//  console.log(de)
       // this.deltaDataset = this.calcularDeltaAbsoluto(fonte2, fonte1, 5)




        // for (let i = 1; i < reference.length; i++)
        // {
        //     const diff = furiacs[i][11]-reference[i][11];
        //     this.deltaDataset.push([reference[i][0], diff]);
        //     this.referenceTime[reference[i][0]] = reference[i][11];

        //     referenceCoords.push([reference[i][8],reference[i][9],reference[i][10], reference[i][1]])
        // }

        // for (let i = 1; i < furiacs.length; i++)
        //     furiacsCoords.push([furiacs[i][8],furiacs[i][9],furiacs[i][10], furiacs[i][1]])
   


        this.option = {
            backgroundColor: '#000',
            dataZoom: [
                {
                    type: 'inside',
                    xAxisIndex: [0],
                    start: 0,
                    end: 100
                },
                {
                    type: 'slider',
                    show: true,
                    xAxisIndex: [0,1,2,3,4],
                    start: 0,
                    end: 100,
                    top: 900,
                   // handleSize: 20
                    moveHandleSize: 20
                }
            ],
            axisPointer: 
            {
                link: { 
                    xAxisIndex: 'all' 
                    
                },
                label: 
                {
                    backgroundColor: '#777'
                },
                lineStyle: {
                    type: 'solid',
                    color: '#FFFF00'
                }
            },
            tooltip: {
                show: true,
                trigger: 'axis',
                formatter: (params, p2) =>
                {

                    this.zoomToPoint(params[0].data)

                   return `${params[0].data[0]}, Delta: ${params[1].data[11].toFixed(3)}<br>
                    Distance: <b>R ${params[0].data[0]}</b> F: ${params[1].data[0]}<br>
                    Speed: <b>R ${params[0].data[1]}</b> F: ${params[1].data[1]}<br>
                    Throttle: <b>R ${params[0].data[2]}</b> F: ${params[1].data[2]}<br>
                    Brakes: <b>R ${params[0].data[3]}</b> F: ${params[1].data[3]}<br>
                    Gear: <b>R ${params[0].data[4]}</b> F: ${params[1].data[4]}<br>
                    RPM: <b>R ${params[0].data[5]}</b> F: ${params[1].data[5]}<br>
                    Coasting: <b>R ${params[0].data[6]}</b> F: ${params[1].data[6]}<br>
                    Steering: <b>R ${params[0].data[7]}</b> F: ${params[1].data[7]}<br>
                    `;            
                }   
              },
            dataset: [
                {
                    source: referenceData
                },
                {
                    source: furiacsData
                },
                {
                    source: this.deltaDataset
                },
                {
                    source: this.pointerCoords
                }
                // {
                //     source: this.realtime
                // },
                // {
                //     source: this.realtimeDeltaDataset
                // }                
            ],               
            title: {
              text: 'Reference vs Furiacs'
            },
            grid: [
                {
                    width: '70%',
                    height: '200px',
                    top: '50px',
                },
                {
                    width: '70%',
                    height: '100px',
                    top: '300px'
                },            
                {
                    width: '70%',
                    height: '100px',
                    top: '450px'
                },
                {
                    width: '70%',
                    height: '100px',
                    top: '600px'
                },
                {
                    width: '70%',
                    height: '100px',
                    top: '750px'
                },
            ],
       
         
            toolbox: {

              },
            xAxis: [
                {
                    type: 'value',
                    gridIndex: 0
                },
                {
                    type: 'value',
                    gridIndex: 1
                },
                {
                    type: 'value',
                    gridIndex: 2
                },
                {
                    type: 'value',
                    gridIndex: 3
                },
                {
                    type: 'value',
                    gridIndex: 4
                }
            ],
            yAxis: [
                {
    
                    type: 'value',
                    //min: 0,
                    //max: 350,
                    gridIndex: 0,
                    splitLine: this.yAxisSplitLine
                },
                {
          
                    type: 'value',
                    gridIndex: 1,
                    splitLine: this.yAxisSplitLine
                },
                {
          
                    type: 'value',
                    gridIndex: 2,
                    inverse: false,
                    splitLine: this.yAxisSplitLine
                },
                {
          
                    type: 'value',
                    gridIndex: 3,
                    splitLine: this.yAxisSplitLine
                },
                {
                   /* min: -4,
                    max: 4,*/
                    type: 'value',
                    gridIndex: 4,
                    splitLine: this.yAxisSplitLine
                }
            ],
            // geo: {
            //     map: 'Map',
            //     roam: true,
            //     emphasis: {
            //         itemStyle: {
            //             color: undefined
            //         },
            //         label: {
            //             show: false
            //         }
            //     },
            //     //top: 'top',
            //     //left: 100,
            //     left: 0, top: 0, right: 0, bottom: 0,
            //     //zoom:0.99,
            //  },

            series: [
                {
                    name: 'Reference',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 0,
                    encode: {
                        x: ['distance'],
                        y: ['speed'],
                    },
                    //color: 'black',
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    symbol: 'none',
                    lineStyle: this.lineStyles.reference
                },
                {
                    name: 'Furiacs',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 1,
                    encode: {
                        x: ['distance'],
                        y: ['speed'],
                    },
                    //color: 'orange',
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    symbol: 'none',
                    lineStyle: this.lineStyles.furiacs
                },
                // {
                //     name: 'Realtime',
                //     type: 'line',
                //     dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'time'], 
                //     datasetIndex: 3,
                //     encode: {
                //         x: ['distance'],
                //         y: ['speed'],
                //     },
                //     //color: 'orange',
                //     xAxisIndex: 0,
                //     yAxisIndex: 0,
                //     symbol: 'none',
                //     lineStyle: this.lineStyles.realtime
                // },                
                {
                    name: 'Reference',
                    type: 'line',
                    center: ['50%', '25%'],
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 0,
                    encode: {
                        x: ['distance'],
                        y: ['throttle'],
                    },
                    
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    symbol: 'none',
                    lineStyle: this.lineStyles.reference,
                    /*areaStyle:{
                        color: 'black',
                        opacity: 0.3
                    }*/
                    
                },
                {
                    name: 'Furiacs',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 1,
                    encode: {
                        x: ['distance'],
                        y: ['throttle'],
                    },
                    
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    symbol: 'none',
                    lineStyle: this.lineStyles.furiacs,
                    /*areaStyle:{
                        color: 'orange',
                        opacity: 0.3
                    }*/
                },
                // {
                //     name: 'Realtime',
                //     type: 'line',
                //     dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'time'], 
                //     datasetIndex: 3,
                //     encode: {
                //         x: ['distance'],
                //         y: ['throttle'],
                //     },
                    
                //     xAxisIndex: 1,
                //     yAxisIndex: 1,
                //     symbol: 'none',
                //     lineStyle: this.lineStyles.realtime,
                //     /*areaStyle:{
                //         color: 'orange',
                //         opacity: 0.3
                //     }*/
                // },                
                {
                    name: 'Reference',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 0,
                    encode: {
                        x: ['distance'],
                        y: ['brake'],
                    },
                    
                    xAxisIndex: 2,
                    yAxisIndex: 2,
                    symbol: 'none',
                    lineStyle: this.lineStyles.reference,
                },
                {
                    name: 'Furiacs',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 1,
                    encode: {
                        x: ['distance'],
                        y: ['brake'],
                    },
                    
                    xAxisIndex: 2,
                    yAxisIndex: 2,
                    symbol: 'none',
                    lineStyle: this.lineStyles.furiacs,
                },             
                // {
                //     name: 'Realtime',
                //     type: 'line',
                //     dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'time'], 
                //     datasetIndex: 3,
                //     encode: {
                //         x: ['distance'],
                //         y: ['brake'],
                //     },
                    
                //     xAxisIndex: 2,
                //     yAxisIndex: 2,
                //     symbol: 'none',
                //     lineStyle: this.lineStyles.realtime,
                // },                
                {
                    name: 'Reference',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 0,
                    encode: {
                        x: ['distance'],
                        y: ['gear'],
                    },
                    
                    xAxisIndex: 3,
                    yAxisIndex: 3,
                    symbol: 'none',
                    lineStyle: this.lineStyles.reference
                },
                {
                    name: 'Furiacs',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 1,
                    encode: {
                        x: ['distance'],
                        y: ['gear'],
                    },
                    
                    xAxisIndex: 3,
                    yAxisIndex: 3,
                    symbol: 'none',
                    lineStyle: this.lineStyles.furiacs                
                },  
                // {
                //     name: 'Realtime',
                //     type: 'line',
                //     dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'time'], 
                //     datasetIndex: 3,
                //     encode: {
                //         x: ['distance'],
                //         y: ['gear'],
                //     },
                    
                //     xAxisIndex: 3,
                //     yAxisIndex: 3,
                //     symbol: 'none',
                //     lineStyle: this.lineStyles.realtime                
                // },                             
                // {
                //     name: 'Reference',
                //     type: 'line',
                //     datasetIndex: 2,
                //     xAxisIndex: 4,
                //     yAxisIndex: 4,
                //     symbol: 'none',
                //     lineStyle: this.lineStyles.furiacs
                // },
                {
                    name: 'Furiacs',
                    type: 'line',
                    dimensions: ['distance','speed','throttle','brake','gear', 'rpm', 'coasting', 'steering', 'worldX', 'worldY', 'worldZ', 'delta'], 
                    datasetIndex: 1,
                    encode: {
                        x: ['distance'],
                        y: ['delta'],
                    },
                    
                    xAxisIndex: 4,
                    yAxisIndex: 4,
                    symbol: 'none',
                    lineStyle: this.lineStyles.delta           
                },                
             /*   {
                    name: 'Reference',
                    type: 'line',
                    datasetIndex: 4,
                    xAxisIndex: 4,
                    yAxisIndex: 4,
                    symbol: 'none',
                    lineStyle: this.lineStyles.realtime
                }, */               
                {
                    type: 'line3D',
                    data: referenceCoords,
                    lineStyle: {
                      width: 1,
                      color: 'purple',
                    },
                    
                    grid3DIndex: 0,
                   // smooth: true
                },
                {
                    type: 'line3D',
                    data: furiacsCoords,
                    lineStyle: {
                      width: 1,
                      color: 'green',
                    },
                    
                    grid3DIndex: 0,
                   // smooth: true
                },
                {
                    type: 'scatter3D',
                    data: this.pointerCoords, 
                    symbol: 'circle',
                    symbolSize: 10,
                    color: 'yellow',
                    grid3DIndex: 0,
                   //smooth: true
               }                
                /*{
                    name: '3dpointer',
                    type: 'scatterGL',
                    data: [this.mapPointer],
                    symbol: 'diamond',
                    symbolSize: 10,
                    itemStyle: {
                      color: 'green'
                    },
                    grid3DIndex: 0
                },*/
            ],
            /*visualMap: {
                show: false,
                dimension: 3,
                min: 0,
                max: 400,
                inRange: {
                  color: ['white', 'red'],
                  //colorAlpha: [0,100]
                },
                seriesIndex: 10,
              },*/
              grid3D: {
                viewControl: {
                projection: 'orthographic',
                alpha: 180,
                beta: 0,
                center: [0,0,0],
                //  animation: false,
                 // rotateSensitivity: 0,
                  //panSensitivity: 1,
                 // zoomSensitivity: 1,
                  //distance: 50,
                 orthographicSize: 300,
                 // center: [-20,0,0]
                },
                //postEffect: { enable: false },
                //temporalSuperSampling: { enable: false },
                show: false,
                width: '300px',
                height: '800px',
                left: '80%',
                /*width: '300px',
                height: '300px',
                top: '20px',
                right: '20px',*/
                axisLine: {
                    lineStyle: {
                      color: '#fff'
                    }
                  },
                  axisPointer: {
                    lineStyle: {
                      color: '#ffbd67'
                    }
                  },
              },
              xAxis3D: {
                type: 'value',
                show: true,
                splitLine: {show: true}
              },
              yAxis3D: {
                type: 'value',
                //show: true
              },
              zAxis3D: {
                type: 'value',
                //show: true
              }   
              ,
            graphic: [
                {
                    type: 'text',
                    right: '90px',
                    style: {
                        //text: 'Delta:',
                        y: 90
                    }
                }
            ]
          };

          this.loaded = true;        
    }

    public onChartDataZoom(event)
    {
        //console.log(event);


        const dataZoom = this.instance.getOption().dataZoom[1];

        if (this.deltaDataset.length > dataZoom.startValue && this.deltaDataset.length > dataZoom.endValue)
        {
            // Calcula o delta de tempo na janela
            const windowDelta = this.deltaDataset[dataZoom.endValue][1]-this.deltaDataset[dataZoom.startValue][1];

            // Atualiza os dados
            this.update = {
                graphic: [
                    {
                          style: {
                            text: 'Delta: ' + windowDelta.toFixed(3)
                        }
                    }
                ]
            };
        }


    }
}
